import React from 'react';
import { Thumbnail } from '@icecreamsocial/components';
import stripeLogo from '../../../assets/logo_stripe_blurple.svg';

const StripeLogo = ({ ...props }) => <Thumbnail src={stripeLogo} {...props} />;

StripeLogo.displayName = 'StripeLogo';

export default StripeLogo;
